import { useEffect, useState } from "react";

/**
 * Custom hook to fetch JSON data from an S3 URL.
 * 
 * @param {string} url - The URL of the S3 JSON file.
 * @returns {Object} - An object containing { data, loading, error }.
 */
export const useS3Data = (url) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!url || typeof url !== "string" || !/^https?:\/\//i.test(url.trim())) {
      setData(null);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Failed to fetch S3 data: ${response.statusText}`);
        }
        const jsonData = await response.json();
        setData(jsonData);
      } catch (err) {
        console.error("useS3Data error:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [url]);

  return { data, loading, error };
};
